import { Tag, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { EventType } from "@models/event";
import { compareText } from "@models/utils";
import { useMemo } from "react";

const EventDetailTag = ({
  tags: tags = [],
  eventType,
}: {
  tags?: string[];
  eventType: EventType;
}) => {
  const { colorMode } = useColorMode();
  const typeTextColor = useMemo(() => {
    switch (eventType) {
      case EventType.BENEFIT:
        return colorMode === "light"
          ? "tags.benefit.light.text"
          : "tags.benefit.dark.text";
      case EventType.MEMBERSHIP:
        return "#FFFFFF";
      default:
      case EventType.TICKET:
        return colorMode === "light"
          ? "tags.ticket.light.text"
          : "tags.ticket.dark.text";
    }
  }, [colorMode, eventType]);

  const typeBgColor = useMemo(() => {
    switch (eventType) {
      case EventType.BENEFIT:
        return colorMode === "light"
          ? "tags.benefit.light.bg"
          : "tags.benefit.dark.bg";
      case EventType.MEMBERSHIP:
        return "#7B61FF";
      default:
      case EventType.TICKET:
        return colorMode === "light"
          ? "tags.ticket.light.bg"
          : "tags.ticket.dark.bg";
    }
  }, [colorMode, eventType]);

  const typeContent = useMemo(() => {
    if (compareText(eventType, EventType.TICKET)) return "Event";
    return eventType;
  }, [eventType]);

  const typeTag = (
    <Tag
      key={-1}
      mr={2}
      mb={2}
      borderRadius="0.25rem"
      size="lg"
      variant="solid"
      bgColor={typeBgColor}
      color={typeTextColor}
      textTransform={"capitalize"}
    >
      {typeContent}
    </Tag>
  );

  const tabBgColor = useColorModeValue(
    "tags.custom.light.bg",
    "tags.custom.dark.bg"
  );
  const tabTextColor = useColorModeValue(
    "tags.custom.light.text",
    "tags.custom.dark.text"
  );
  return (
    <div className="flex flex-row items-center mt-4 flex-wrap">
      {typeTag}
      {tags.map((tag, index) => (
        <Tag
          key={index}
          mr={2}
          mb={2}
          borderRadius="0.25rem"
          size="lg"
          variant="solid"
          bgColor={tabBgColor}
          color={tabTextColor}
        >
          {tag}
        </Tag>
      ))}
    </div>
  );
};

export default EventDetailTag;
